import { gql } from '@apollo/client'
import { Caption, Heading, Subtitle } from '@farol-ds/react'
import { Price } from '@jusbrasil-web/shared-price'
import classNames from 'classnames'

import { BenefitsList } from '../benefits-list'
import { CheckoutButton } from '../checkout-button'
import { OneClickButton } from '../one-click-button'
import {
  UpgradePlanLockContent_OfferLockDataFragment,
  UpgradePlanLockContent_ViewerFragment,
} from './__generated__/upgrade-plan-lock-content.graphql'
import styles from './upgrade-plan-lock.module.scss'

export interface UpgradePlanLockContentProps {
  offerLockData: UpgradePlanLockContent_OfferLockDataFragment
  viewer: UpgradePlanLockContent_ViewerFragment
}
export function UpgradePlanLockContent({ offerLockData, viewer }: UpgradePlanLockContentProps) {
  const { header, footer } = offerLockData || {}
  const { title = '', subtitle = '' } = header || {}
  const card = offerLockData.body.cards[0]
  const currentPrice = card.offer.currentPlanPriceText
  const upgradedPrice = card.offer.priceText
  const frequency = card.offer.frequency

  const oneClickButtonWrapperClasses = classNames({
    [styles['upgrade-plan-lock-wrapper-button']]: !!card.creditCard,
  })

  return (
    <>
      <div className={styles['upgrade-plan-lock-header']}>
        <Heading className={styles['upgrade-plan-lock-title']} size="lg" asChild>
          <h3>{title}</h3>
        </Heading>
        <Subtitle className={styles['upgrade-plan-lock-subtitle']} size="md">
          {subtitle}
        </Subtitle>
      </div>

      <Price className={styles['upgrade-plan-lock-price']} align="center" size="md">
        <Price.Discount>
          Seu plano passará de{' '}
          <strong>
            {currentPrice} {'/' + frequency}
          </strong>{' '}
          para
        </Price.Discount>
        <Price.Value>
          {upgradedPrice}
          {frequency && upgradedPrice && <Price.ValueFrequency>{frequency}</Price.ValueFrequency>}
        </Price.Value>
      </Price>

      <CheckoutButton offerLockCard={card} kind="primary" />
      <div className={oneClickButtonWrapperClasses}>
        <OneClickButton offerLockCard={card} viewer={viewer} kind="primary" />
      </div>
      <BenefitsList
        offerLockCard={card}
        benefitsListClassName={styles['upgrade-plan-lock-benefits']}
      />

      {footer && footer.text && (
        <div className={styles['upgrade-plan-lock-footer']}>
          <Caption className={styles['upgrade-plan-lock-footer-text']}>{footer.text}</Caption>
        </div>
      )}
    </>
  )
}

UpgradePlanLockContent.fragments = {
  offerLockData: gql`
    fragment UpgradePlanLockContent_offerLockData on OfferLockData {
      header {
        title
        subtitle
      }
      body {
        cards {
          offer {
            frequency
            currentPlanPriceText
            priceText
          }
          ...OneClickButton_offerLockCard
          ...CheckoutButton_offerLockCard
          ...BenefitsList_offerLockCard
        }
      }
      footer {
        text
      }
    }
    ${OneClickButton.fragments.offerLockCard}
    ${CheckoutButton.fragments.offerLockCard}
    ${BenefitsList.fragments.offerLockCard}
  `,
  viewer: gql`
    fragment UpgradePlanLockContent_viewer on Profile {
      ...OneClickButton_viewer
    }
    ${OneClickButton.fragments.viewer}
  `,
}
